import { render, staticRenderFns } from "./ListTraining.vue?vue&type=template&id=edcd99ce&"
import script from "./ListTraining.vue?vue&type=script&lang=js&"
export * from "./ListTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports